import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { CreateSchoolCafeteriaForm } from '@/features/create-school-cafeteria'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute(
  '/_auth/administration/reference-books/canteens/connects/create'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Создание связи школа - столовая')}>
      <CreateSchoolCafeteriaForm onClose={close} />
    </Offcanvas>
  )
}
